import React from "react";
import MoreIcon from '@material-ui/icons/MoreHoriz';
import ClearIcon from '@material-ui/icons/Clear';
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import "./landscape-player-gallery.scss";

import { loadPlayerLeaderBoard } from "../store/actions/leader_board";
import { closeGameLauncher } from "../../store/actions/games";

import { formatNumber } from "../utils/functions";
import Watch from "../assets/watch.svg";
import DefaultAvatar from "../assets/img-avatar-male.png";
import Timer from "./timer";

import PosBg from "../assets/pos-bg.svg";
import DialogObjectives from "../dialogs/dialog-rules";
import DialogSwitchTournament from "../dialogs/dialog-switch-tournament";
import AwardIcon from "../assets/award.svg";
import { getData } from "../../lobby/utils/functions";

const differentArray = (left, right) => {
  if (left.length !== right.length) return true;

  for (let i = 0; i < left.length; i++) {
    const keys = Object.keys(left[i]);
    for (let j = 0; j < keys.length; j++) {
      if (left[i][keys[j]] !== right[i][keys[j]]) {
        return true;
      }
    }
  }

  return false;
};

const PlayerGallery = (props) => {
  const { tournament, t, rank, loadPlayerLeaderBoard, authentication, closeGameLauncher, history, routerHistory, activeGame } = props;

  const [openObjectivesDialog, setOpenObjectivesDialog] = React.useState(false);
  const handleCloseObjectivesDialog = (e) => {
    if (e) e.stopPropagation();
    setOpenObjectivesDialog(false);
  };
  const showRules = (e) => {
    if (e) e.stopPropagation();
    setOpenObjectivesDialog(true);
  };

  const [openTournamentsDialog, setOpenTournamentsDialog] = React.useState(false);
  const handleCloseTournamentsDialog = (e) => {
    if (e) e.stopPropagation();
    setOpenTournamentsDialog(false);
  };
  const showMenu = (e) => {
    if (e) e.stopPropagation();
    setOpenTournamentsDialog(true);
  };
  const closeGame = () => {
    closeGameLauncher();
    localStorage.removeItem("fromGame");
    if (routerHistory?.pages > 1) {
      let gotoPage = '';
      routerHistory?.pagesHistory?.length && routerHistory.pagesHistory.find((page, index) => {
        if (
          page.indexOf("/play/") === -1 &&
          page.indexOf("/deposit") === -1 &&
          page.indexOf("/connect") === -1 &&
          page.indexOf("/payment/") === -1
        ) {
          gotoPage = page;
          return true;
        }
        return false;
      });
      if (gotoPage) {
        history.push(gotoPage);
        return;
      }
    }
    history.push("/cazino/jocuri");
  };
  const showDeposit = (e) => {
    if (e) e.stopPropagation();
    localStorage.setItem("fromGame", JSON.stringify(activeGame));
    closeGameLauncher();
    history.push("/deposit#nb");
  };

  const [players, setPlayers] = React.useState([]);

  React.useEffect(() => {
    let isAuthenticated = false;
    if (authentication && ["user", "token"].indexOf(authentication.auth_type) > -1) {
      isAuthenticated = true;
    }

    if (isAuthenticated && tournament && rank && rank[tournament.id] && rank[tournament.id].player && differentArray(rank[tournament.id].player, players)) {
      setPlayers(JSON.parse(JSON.stringify(rank[tournament.id].player)));
    }
  }, [tournament, rank, players, authentication]);

  React.useEffect(() => {
    if (tournament && rank && !rank[tournament.id]) {
      loadPlayerLeaderBoard({ tournamentId: tournament.id, inGame: true });
    }
  }, [tournament, rank, loadPlayerLeaderBoard]);

  if (!tournament) return;

  let tmpIndex = -1;
  let finalPlayers = JSON.parse(JSON.stringify(players));
  finalPlayers && finalPlayers.length && finalPlayers.forEach((p, i) => {
    if (p.me) {
      tmpIndex = i;
    }
  });

  const lastIndex = finalPlayers.length - 1;

  if (tmpIndex !== -1) {
    let fp = tmpIndex - 1;
    if (fp < 0) fp = 0;
    let lp = fp + 4;

    if (lp > lastIndex) {
      lp = lastIndex;
      fp = lp - 4;
      if (fp < 0) fp = 0;
    }
    if (window.config.platformType.toString() !== '1') finalPlayers = finalPlayers.slice(fp, fp + 4);
  }

  let currentPlayer = null;
  let currentPlayerPos = -1;
  finalPlayers && finalPlayers.length && finalPlayers.forEach((p, i) => {
    if (p.me) {
      currentPlayer = p;
      currentPlayerPos = i;
    }
  });

  const avatar_image = getData(tournament, "meta.ui.avatar_image.url", DefaultAvatar);

  return (
    <div className="landscape-player-gallery" key={`id-${tournament.id}`}>

      <div className="header-wrapper">
        <div className="menus">
          <div className="menu close" onClick={closeGame}>
            <ClearIcon />
          </div>
          <div className="menu" onClick={showMenu}>
            <MoreIcon />
          </div>
        </div>
        <div className="menus">
          <div className="deposit" onClick={showDeposit}>
            {t("Deposit")}
          </div>
        </div>
        <div className="header">
          <div className="tmr">
            <img src={Watch} alt="" />
            <Timer date={tournament.end_date}>
              {({ days, hours, mins, secs }) => {
                return `${!!days ? (days > 1 ? `${days} ${t("days")} ` : `${days} ${t("day")} `) : ""}${hours}:${mins}:${secs}`;
              }}</Timer>
          </div>
        </div>
        <div className="hr"></div>
      </div>
      {finalPlayers.length === 0 && <div className="gallery-wrapper" onClick={showRules}>
        <div className="empty">{t("The tournament rankings will appear soon")}</div>
      </div>
      }
      {finalPlayers.length !== 0 && <div className={`gallery-wrapper ${window.config.platformType.toString() !== '1' ? 'mobile' : ''}`} onClick={showRules}>
        <div className="gallery  real">
          <div className="container before"></div>

          {
            finalPlayers.map((p, i) => {
              return <div key={i} className={`item no-${i + 1} ${i === currentPlayerPos ? 'current' : ''}`}>
                <div className="avatar">
                  <img src={typeof p.avatar === "string" ? p.avatar : typeof p.avatar === "object" && p.avatar && p.avatar.url ? p.avatar.url : avatar_image} alt="" />
                </div>
                <div className="pos">
                  <img src={PosBg} alt="" />
                  <div className="no">#{p.pos}</div>

                </div>
                <div className="score">{formatNumber(p.score, props.i18n.language)}</div>
              </div>
            })
          }

          <div className="container after"></div>
        </div>
        {currentPlayer &&
          <div className="gallery float">
            {
              finalPlayers.map((p, i) => {

                if (currentPlayerPos !== i) return <div key={i} className={`item`}>
                  <div className="avatar off">
                  </div>
                  <div className="pos"></div>
                  <div className="score">&nbsp;</div>
                </div>;

                return <div className={`item big`} key={'current-player-float'}>
                  <div className="avatar">
                    <img src={typeof currentPlayer.avatar === "string" ? currentPlayer.avatar : typeof currentPlayer.avatar === "object" && currentPlayer.avatar && currentPlayer.avatar.url ? currentPlayer.avatar.url : avatar_image} alt="" />
                  </div>
                  <div className="pos">
                    <img src={PosBg} alt="" />
                    <div className="no">#{currentPlayer.pos}</div>
                    <div className="award-icon">
                      <img src={AwardIcon} alt="" />
                    </div>
                  </div>
                  <div className="score">{formatNumber(currentPlayer.score, props.i18n.language)}</div>
                </div>;
              })
            }
          </div>
        }
      </div>}

      {openObjectivesDialog && <DialogObjectives open={openObjectivesDialog} onClose={handleCloseObjectivesDialog} tournament={tournament} groupUrl={props.groupUrl} />}
      {openTournamentsDialog && <DialogSwitchTournament open={openTournamentsDialog} onClose={handleCloseTournamentsDialog} />}
    </div>
  );
}

const mapStateToProps = (state, props) => {
  return {
    routerHistory: state.application.routerHistory,
    activeGame: window.config.platformType?.toString() === '1' ? state.games.actualGame : state.games.activeGame,
    authentication: state.authentication,
    rank: state.tournamentsMissions ? state.tournamentsMissions.leaderboard.player : {},
  }
};

const actions = {
  loadPlayerLeaderBoard,
  closeGameLauncher
};

export default withRouter(connect(mapStateToProps, actions)(withTranslation()(PlayerGallery)));